// extracted by mini-css-extract-plugin
export var indeterminate = "_2c-6";
export var md = "_2c-5";
export var semantic = "_2c-7";
export var sm = "_2c-4";
export var text = "_2c-8";
export var toggleControl = "_2c-0";
export var toggleInput = "_2c-1";
export var toggleSwitch = "_2c-2";
export var xs = "_2c-3";